// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__FwMJR","body":"style__body__nqt3G"};